import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {Chacra} from "../../../../../chacra-core/models/chacra";

export const chacrasAdapter: EntityAdapter<Chacra> = createEntityAdapter<Chacra>({
  selectId: model => model.rendimientoId,
  sortComparer: (a: Chacra, b: Chacra): number =>
    b.rendimientoId.toString().localeCompare(a.rendimientoId.toString())
});

export interface ChacrasState extends EntityState<Chacra> {
  isLoading?: boolean;
  getSuelosLoading?: boolean;
  error?: string | null;
  changePendiente: Chacra;
}

export const initialState: ChacrasState = chacrasAdapter.getInitialState(
  {
    isLoading: false,
    getSuelosLoading: false,
    error: null,
    changePendiente: null
  }
);
